import { render } from "./WordOfDay.vue?vue&type=template&id=c9c764c2"
import script from "./WordOfDay.vue?vue&type=script&lang=js"
export * from "./WordOfDay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__